module.exports = __webpack_public_path__ + "img/Yemen.cd13006c.svg";